/**
 * What the site root shows: the landing, or the cabinet it redirects to.
 *
 * In a browser tab the root is the site: a signed-in user who typed lupaapp.ru wants to read it,
 * and the landing's header already offers «Личный кабинет» (Никита, 01.10.2026: «из личного
 * кабинета никак не перейти на лендинг… захожу на сайт, а он сразу в менеджер»). The cabinet wins
 * in two cases only:
 * - the installed app (PWA): it launches at `start_url: '/'`, and an app icon that opens a
 *   marketing page would be broken;
 * - right after a sign-in the user started — every sign-in button returns to the root, and
 *   someone who just typed their password came for the cabinet.
 */
export function homeCabinet(input: {
  authenticated: boolean
  activeRole: string
  standalone: boolean
  returnedFromSignIn: boolean
}): string | null {
  if (!input.authenticated || !input.activeRole) return null
  if (!input.standalone && !input.returnedFromSignIn) return null
  return input.activeRole === 'manager' ? '/manager' : '/driver'
}
